import React from "react";

import { DEAL_TYPE_KEYS, ENTRY_DATA_SECTION_KEYS } from "@frontend/common";

import { useCheckClassificationPreclinical } from "@FillInTableContainer/components/FillInTable/components/TableCreator/components/ClinicalTrialsTableCreator/hooks/useCheckClassificationPreclinical";
import { DEALS_GROUP_KEY } from "@FillInTableContainer/shared/constants/dealsKey.constants";
import { useCurrentDealTypeValue } from "@FillInTableContainer/shared/context/CurrentDealTypeContext";
import { useHandleTableCreatorWrapperPositionInfo } from "@FillInTableContainer/shared/hooks/useHandleTableCreatorWrapperPositionInfo";
import { ArticleSectionType } from "@FillInTableContainer/types/fillInTable.types";

import FillInTableNavigation from "./components/FillInTableNavigation/FillInTableNavigation";
import { NAVIGATION_LIST } from "./constants/fillInTableNavigationList.constants";
import * as S from "./TableCreatorNavigationTableWrapper.style";

interface Props {
  classificationKey: ArticleSectionType;
  children: JSX.Element;
}

const TableCreatorNavigationTableWrapper = ({
  classificationKey,
  children,
}: Props) => {
  const { tableCreatorWrapperRef } = useHandleTableCreatorWrapperPositionInfo();

  const { isMergeAndAcquisition, currentDealTypeList } =
    useCurrentDealTypeValue();

  const { isPreclinical } = useCheckClassificationPreclinical();
  const returnNavigationList = () => {
    if (isPreclinical) {
      // NOTE : Preclinical인 경우 Drug Profile 메뉴만 표출
      return NAVIGATION_LIST[classificationKey].filter(
        (item) => item.sectionKey === "Drug Profile",
      );
    }
    if (classificationKey === ENTRY_DATA_SECTION_KEYS.deals) {
      // NOTE : Deals 는 Deal Type Category 에 따라 Deal Terms/Key Comment 를
      // V1(M&A·순수 Venture Formation) 또는 V2(LA&SC, 그 외)로 상호배타 렌더한다. 네비도 이에 맞춘다.
      // - M&A·순수 VF: V1 메뉴만 표출
      // - 그 외: 공용(Drug Profile·Deal Type) + V2(LA&SC) 메뉴. V1 Deal Terms/Key Comment 는 렌더되지 않으므로 제외
      if (
        isMergeAndAcquisition ||
        (currentDealTypeList.includes(DEAL_TYPE_KEYS.ventureFormation) &&
          !currentDealTypeList.includes(DEAL_TYPE_KEYS.licenseAgreement))
      )
        return NAVIGATION_LIST[classificationKey];
      return [
        ...NAVIGATION_LIST[classificationKey].filter(
          (item) =>
            item.sectionKey !== DEALS_GROUP_KEY.dealTerms &&
            item.sectionKey !== DEALS_GROUP_KEY.keyComment,
        ),
        ...NAVIGATION_LIST[ENTRY_DATA_SECTION_KEYS.dealsLaSc],
      ];
    }

    return NAVIGATION_LIST[classificationKey];
  };
  const currentNavigationList = returnNavigationList();

  return (
    <S.TableCreatorWrapper>
      <FillInTableNavigation itemList={currentNavigationList} />
      <S.GroupTableWrapper ref={tableCreatorWrapperRef}>
        {children}
      </S.GroupTableWrapper>
    </S.TableCreatorWrapper>
  );
};

export default TableCreatorNavigationTableWrapper;
